module.exports = __webpack_public_path__ + "img/reward.740f0319.svg";